// API configuration
// Lämna tom/relativ bas, så dev-proxy (package.json "proxy") hanterar /api till backend
export const API_BASE_URL = '';

// Backend origin for direct file access (iframe/embed).
// CRA's dev proxy only works for XHR/fetch, not for iframe src or embed src.
// In production the same origin serves both frontend and backend, so empty string works.
// In dev (port 3000), we need the actual backend origin (port 3002).
export const BACKEND_ORIGIN =
  window.location.port === '3000' ? 'http://localhost:3002' : '';
